// src/plugins/primevue.js
import PrimeVue from "primevue/config";
import aura from "@primevue/themes/aura";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";
import {
  DARK_MODE_SELECTOR,
  applyThemePreference,
} from "@/shared/theme/themePreference.mjs";
const pl = {
  firstDayOfWeek: 1,
  dayNames: [
    "niedziela",
    "poniedziałek",
    "wtorek",
    "środa",
    "czwartek",
    "piątek",
    "sobota",
  ],
  dayNamesShort: ["niedz", "pon", "wt", "śr", "czw", "pt", "sob"],
  dayNamesMin: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb"],
  monthNames: [
    "styczeń",
    "luty",
    "marzec",
    "kwiecień",
    "maj",
    "czerwiec",
    "lipiec",
    "sierpień",
    "wrzesień",
    "październik",
    "listopad",
    "grudzień",
  ],
  monthNamesShort: [
    "sty",
    "lut",
    "mar",
    "kwi",
    "maj",
    "cze",
    "lip",
    "sie",
    "wrz",
    "paź",
    "lis",
    "gru",
  ],
  today: "Dzisiaj",
  clear: "Wyczyść",
  weekHeader: "Tydz.",
  accept: "Tak",
  reject: "Nie",
  choose: "Wybierz",
  upload: "Prześlij",
  cancel: "Anuluj",
  emptyMessage: "Brak dostępnych opcji",
  emptyFilterMessage: "Brak wyników",
  emptySearchMessage: "Brak wyników",
  selectionMessage: "Wybrano {0} elementów",
  emptySelectionMessage: "Nie wybrano żadnego elementu",
};

import Accordion from "primevue/accordion";
import Tag from "primevue/tag";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Card from "primevue/card";
import Checkbox from "primevue/checkbox";
import Column from "primevue/column";
import ConfirmDialog from "primevue/confirmdialog";
import DataTable from "primevue/datatable";
import DatePicker from "primevue/datepicker";
import Dialog from "primevue/dialog";
import FloatLabel from "primevue/floatlabel";
import InputNumber from "primevue/inputnumber";
import InputOtp from "primevue/inputotp";
import InputText from "primevue/inputtext";
import Menubar from "primevue/menubar";
import Message from "primevue/message";
import MultiSelect from "primevue/multiselect";
import RadioButton from "primevue/radiobutton";
import ScrollPanel from "primevue/scrollpanel";
import Select from "primevue/select";
import SelectButton from "primevue/selectbutton";
import Step from "primevue/step";
import StepList from "primevue/steplist";
import StepPanel from "primevue/steppanel";
import StepPanels from "primevue/steppanels";
import Stepper from "primevue/stepper";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import Divider from "primevue/divider";

const savedDarkMode = localStorage.getItem("darkMode") === "true";
applyThemePreference(savedDarkMode);

const primeVueConfig = {
  theme: {
    preset: aura,
    options: {
      prefix: "p",
      darkModeSelector: DARK_MODE_SELECTOR,
      cssLayer: false,
      mediaQuery: false,
    },
  },
  locale: pl,
};

export function registerPrimeVue(app) {
  app.use(PrimeVue, primeVueConfig);
  app.use(ToastService);
  app.use(ConfirmationService);
  app.directive("tooltip", Tooltip);
  const components = {
    Divider,
    Tag,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    AutoComplete,
    Button,
    Card,
    Checkbox,
    Column,
    ConfirmDialog,
    DataTable,
    DatePicker,
    Dialog,
    FloatLabel,
    InputNumber,
    InputOtp,
    InputText,
    Menubar,
    Message,
    MultiSelect,
    RadioButton,
    ScrollPanel,
    Select,
    SelectButton,
    Step,
    StepList,
    StepPanel,
    StepPanels,
    Stepper,
    Textarea,
    Toast,
  };

  for (const [name, component] of Object.entries(components)) {
    app.component(name, component);
  }
}
